module.exports = __webpack_public_path__ + "img/title-en-m.b36d8f09.svg";